import { AnalysisRequest, AnalysisRequestState } from '../types/shared/v2/AnalysisRequest'

// Ticket #894 - Le bouton "Rafraîchir les résultats d'analyse" synchronisait
// tous les patients ayant une demande, soit près d'un millier chez l'EFS, ce
// qui occupe pendant des heures les connexions vers Fusion et MatchIt et
// retarde l'intégration des nouveaux résultats.
//
// Un examen n'attend plus rien de Fusion ou MatchIt une fois ses résultats
// transférés à Inlog (stade 6) ou s'il relève de la reprise de l'historique
// (stade 0). Tout autre stade peut encore voir arriver ou changer un résultat :
// feuille exportée, résultat reçu mais pas encore validé, examen à refaire.
const SETTLED_STATES: ReadonlySet<string> = new Set([
  AnalysisRequestState.TransferedResults,
  AnalysisRequestState.Historized,
])

// isAnalysisRequestInProgress indique si au moins un examen de la demande
// n'est pas encore soldé. Une demande dont tous les examens ont été supprimés
// n'a plus rien à attendre.
export function isAnalysisRequestInProgress (request: Pick<AnalysisRequest, 'types'>): boolean {
  return Object.values(request.types ?? {}).some(state => !SETTLED_STATES.has(state))
}

// collectPatientInlogIds retourne les identifiants Inlog distincts des
// patients des demandes, restreints aux demandes en cours si demandé.
export function collectPatientInlogIds (
  requests: Array<Pick<AnalysisRequest, 'ref' | 'types'>>,
  { inProgressOnly }: { inProgressOnly: boolean }
): string[] {
  const inlogIds = new Set<string>()
  for (const request of requests) {
    if (inProgressOnly && !isAnalysisRequestInProgress(request)) continue
    inlogIds.add(request.ref.patient.inlogId)
  }
  return Array.from(inlogIds)
}

export function formatPatientCount (count: number): string {
  return `${count} patient${count > 1 ? 's' : ''}`
}
